export const SESSION_EMAIL_TOKEN = 'EmailToken';
export const SESSION_ACCOUNT_CHECKS_SUCCESS = 'SESSION::CHECK_SUCCESSFUL';
export const EXPIRED = 'SESSION::EXPIRED';
export const SET_TOKEN_VALIDATION = 'SESSION::SET_TOKEN_VALIDATION';
export const VALIDATE_TOKEN = 'SESSION::VALIDATE_TOKEN';
